/**
 * * Модель запроса на обновление названия очереди задач
 */
export default class ProjectNamespaceUpdateNameRequest  {
	/**
	 * * Номер раб области
	 */
	Id!: string;
	/**
	 * * Название
	 */
	Name!: string;
	constructor(obj?: Partial<ProjectNamespaceUpdateNameRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
